import React from "react"
import { TableHeader } from "./TableHeader"
import { TableBody } from "./TableBody"

export const TableRender = ({ tableData }) => {
  return (
    <div className="relative w-full mt-0 pl-3 lg:pl-0 pr-3 lg:pr-0">
      <table className="w-full border-collapse text-xs desk:text-sm relative mt-0">
        <TableHeader
          headerCols={tableData.headerCols}
          colSize={tableData.colSize}
        />
        <TableBody rows={tableData.rows} colSize={tableData.colSize} />
      </table>
    </div>
  )
}
